/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetSafetyIncidentReportResponse } from '../models/get-safety-incident-report-response';
import { GetFormRequest } from '../models/get-form-request';
import { GetByTypeForTable } from '../models/get-by-type-for-table';
import { GetCountDataOfEventType } from '../models/get-count-data-of-event-type';
import { CreateSafetyIncidentReportRequest } from '../models/create-safety-incident-report-request';
import { ChangeEventTypeRequest } from '../models/change-event-type-request';
import { UpdateSafetyIncidentReportRequest } from '../models/update-safety-incident-report-request';
@Injectable({
  providedIn: 'root',
})
class SafetyIncidentReportService extends __BaseService {
  static readonly SafetyIncidentReportGetAllPath = '/SafetyIncidentReport/GetAll';
  static readonly SafetyIncidentReportGetByIdPath = '/SafetyIncidentReport/GetById';
  static readonly SafetyIncidentReportGetByTypeForTablePath = '/SafetyIncidentReport/GetByTypeForTable';
  static readonly SafetyIncidentReportGetByTypeAndProjectForTablePath = '/SafetyIncidentReport/GetByTypeAndProjectForTable';
  static readonly SafetyIncidentReportGetEventCountDataPath = '/SafetyIncidentReport/GetEventCountData';
  static readonly SafetyIncidentReportCreatePath = '/SafetyIncidentReport/Create';
  static readonly SafetyIncidentReportChangeEventTypePath = '/SafetyIncidentReport/ChangeEventType';
  static readonly SafetyIncidentReportSendEmailsPath = '/SafetyIncidentReport/SendEmails';
  static readonly SafetyIncidentReportUpdatePath = '/SafetyIncidentReport/Update';
  static readonly SafetyIncidentReportUploadFilePath = '/SafetyIncidentReport/UploadFile';
  static readonly SafetyIncidentReportDeletePath = '/SafetyIncidentReport/Delete';
  static readonly SafetyIncidentReportDeleteRangePath = '/SafetyIncidentReport/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  SafetyIncidentReportGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetSafetyIncidentReportResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyIncidentReport/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetSafetyIncidentReportResponse>>;
      })
    );
  }  SafetyIncidentReportGetAll(): __Observable<Array<GetSafetyIncidentReportResponse>> {
    return this.SafetyIncidentReportGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetSafetyIncidentReportResponse>)
    );
  }

  /**
   * @param request undefined
   */
  SafetyIncidentReportGetByIdResponse(request: GetFormRequest): __Observable<__StrictHttpResponse<GetSafetyIncidentReportResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyIncidentReport/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetSafetyIncidentReportResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyIncidentReportGetById(request: GetFormRequest): __Observable<GetSafetyIncidentReportResponse> {
    return this.SafetyIncidentReportGetByIdResponse(request).pipe(
      __map(_r => _r.body as GetSafetyIncidentReportResponse)
    );
  }

  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportGetByTypeForTableParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `stageManagerId`:
   */
  SafetyIncidentReportGetByTypeForTableResponse(params: SafetyIncidentReportService.SafetyIncidentReportGetByTypeForTableParams): __Observable<__StrictHttpResponse<Array<GetByTypeForTable>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.type != null) __params = __params.set('type', params.type.toString());
    if (params.stageManagerId != null) __params = __params.set('stageManagerId', params.stageManagerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyIncidentReport/GetByTypeForTable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetByTypeForTable>>;
      })
    );
  }
  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportGetByTypeForTableParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `stageManagerId`:
   */
  SafetyIncidentReportGetByTypeForTable(params: SafetyIncidentReportService.SafetyIncidentReportGetByTypeForTableParams): __Observable<Array<GetByTypeForTable>> {
    return this.SafetyIncidentReportGetByTypeForTableResponse(params).pipe(
      __map(_r => _r.body as Array<GetByTypeForTable>)
    );
  }

  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportGetByTypeAndProjectForTableParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `projectId`:
   */
  SafetyIncidentReportGetByTypeAndProjectForTableResponse(params: SafetyIncidentReportService.SafetyIncidentReportGetByTypeAndProjectForTableParams): __Observable<__StrictHttpResponse<Array<GetByTypeForTable>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.type != null) __params = __params.set('type', params.type.toString());
    if (params.projectId != null) __params = __params.set('projectId', params.projectId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyIncidentReport/GetByTypeAndProjectForTable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetByTypeForTable>>;
      })
    );
  }
  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportGetByTypeAndProjectForTableParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `projectId`:
   */
  SafetyIncidentReportGetByTypeAndProjectForTable(params: SafetyIncidentReportService.SafetyIncidentReportGetByTypeAndProjectForTableParams): __Observable<Array<GetByTypeForTable>> {
    return this.SafetyIncidentReportGetByTypeAndProjectForTableResponse(params).pipe(
      __map(_r => _r.body as Array<GetByTypeForTable>)
    );
  }

  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportGetEventCountDataParams` containing the following parameters:
   *
   * - `stageManagerId`:
   *
   * - `projectId`:
   */
  SafetyIncidentReportGetEventCountDataResponse(params: SafetyIncidentReportService.SafetyIncidentReportGetEventCountDataParams): __Observable<__StrictHttpResponse<Array<GetCountDataOfEventType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.stageManagerId != null) __params = __params.set('stageManagerId', params.stageManagerId.toString());
    if (params.projectId != null) __params = __params.set('projectId', params.projectId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyIncidentReport/GetEventCountData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetCountDataOfEventType>>;
      })
    );
  }
  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportGetEventCountDataParams` containing the following parameters:
   *
   * - `stageManagerId`:
   *
   * - `projectId`:
   */
  SafetyIncidentReportGetEventCountData(params: SafetyIncidentReportService.SafetyIncidentReportGetEventCountDataParams): __Observable<Array<GetCountDataOfEventType>> {
    return this.SafetyIncidentReportGetEventCountDataResponse(params).pipe(
      __map(_r => _r.body as Array<GetCountDataOfEventType>)
    );
  }

  /**
   * @param request undefined
   */
  SafetyIncidentReportCreateResponse(request: CreateSafetyIncidentReportRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyIncidentReport/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyIncidentReportCreate(request: CreateSafetyIncidentReportRequest): __Observable<string> {
    return this.SafetyIncidentReportCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  SafetyIncidentReportChangeEventTypeResponse(request: ChangeEventTypeRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyIncidentReport/ChangeEventType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyIncidentReportChangeEventType(request: ChangeEventTypeRequest): __Observable<Blob> {
    return this.SafetyIncidentReportChangeEventTypeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param processId undefined
   */
  SafetyIncidentReportSendEmailsResponse(processId?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (processId != null) __params = __params.set('processId', processId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyIncidentReport/SendEmails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param processId undefined
   */
  SafetyIncidentReportSendEmails(processId?: string): __Observable<Blob> {
    return this.SafetyIncidentReportSendEmailsResponse(processId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  SafetyIncidentReportUpdateResponse(request: UpdateSafetyIncidentReportRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/SafetyIncidentReport/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyIncidentReportUpdate(request: UpdateSafetyIncidentReportRequest): __Observable<Blob> {
    return this.SafetyIncidentReportUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportUploadFileParams` containing the following parameters:
   *
   * - `fileType`:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyIncidentReportUploadFileResponse(params: SafetyIncidentReportService.SafetyIncidentReportUploadFileParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.fileType != null) __params = __params.set('fileType', params.fileType.toString());
    if (params.FormId != null) { __formData.append('FormId', params.FormId as string | Blob);}
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyIncidentReport/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SafetyIncidentReportService.SafetyIncidentReportUploadFileParams` containing the following parameters:
   *
   * - `fileType`:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyIncidentReportUploadFile(params: SafetyIncidentReportService.SafetyIncidentReportUploadFileParams): __Observable<Blob> {
    return this.SafetyIncidentReportUploadFileResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  SafetyIncidentReportDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyIncidentReport/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  SafetyIncidentReportDelete(id?: string): __Observable<Blob> {
    return this.SafetyIncidentReportDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  SafetyIncidentReportDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyIncidentReport/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  SafetyIncidentReportDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.SafetyIncidentReportDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SafetyIncidentReportService {

  /**
   * Parameters for SafetyIncidentReportGetByTypeForTable
   */
  export interface SafetyIncidentReportGetByTypeForTableParams {
    type?: 0 | 1 | 2 | 3;
    stageManagerId?: null | string;
  }

  /**
   * Parameters for SafetyIncidentReportGetByTypeAndProjectForTable
   */
  export interface SafetyIncidentReportGetByTypeAndProjectForTableParams {
    type?: 0 | 1 | 2 | 3;
    projectId?: string;
  }

  /**
   * Parameters for SafetyIncidentReportGetEventCountData
   */
  export interface SafetyIncidentReportGetEventCountDataParams {
    stageManagerId?: null | string;
    projectId?: null | string;
  }

  /**
   * Parameters for SafetyIncidentReportUploadFile
   */
  export interface SafetyIncidentReportUploadFileParams {
    fileType?: 0 | 1 | 2 | 3 | 4 | 5;
    FormId?: string;
    File?: null | Blob;
    DirectoryPath?: null | string;
  }
}

export { SafetyIncidentReportService }
